// Founding Support — structured so future categories (Impact Partners,
// Event Partners, Sponsors) slot in without redesign. Logos when supplied.
export const supporters = [
  {
    id: "the-flavor-bag",
    name: "The Flavor Bag",
    category: "Founding Support",
    note: "A business the founders run — a portion of its profits flows straight into the foundation's work.",
    logoUrl: null,
  },
  {
    id: "retrove",
    name: "Retrove",
    category: "Founding Support",
    note: "The foundation's public-facing revenue arm — a merchandise store where 100% of profits fund the work, launching with a first pillar-led collection.",
    logoUrl: null,
  },
  {
    id: "hoppbugs",
    name: "Hoppbugs",
    category: "Founding Support",
    note: "Supporting The PilCoo Foundation's technology and digital needs.",
    logoUrl: null,
  },
];
